import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    navList: [],  // 导航数据
    subList: [], // 二级导航数据
    code: "",  // 跳转code
    name: "" //跳转name
  },
  mutations: {
    'SET_NAVLIST': function (state, payload) {
      state.navList = payload.navList;
    },
    'SET_INFO': function (state, payload) {
      state.code = payload.code;
      state.name = payload.name || "";
    },
    'SET_SUBLIST': function (state, payload) {
      state.subList = [...payload.subList];
    }
  },
  modules: {},
});
